<template>
  <div
    :class="'alert m-b-0 ' + notif_style[type] + ' ' + text_align[align]"
    role="alert"
  >
    <button
      v-if="close"
      aria-label=""
      class="close"
      @click="closeNotif()"
      data-dismiss="alert"
    ></button>
    <strong v-html="title"></strong> <span v-html="subtitle"></span>
  </div>
</template>

<script>
export default {
  name: "alert_dynamic",
  props: {
    type: {
      type: String,
      default: "success",
    },
    title: {
      type: String,
      default: "Title Here",
    },
    subtitle: {
      type: String,
      default: "",
    },
    close: {
      type: Boolean,
      default: true,
    },
    align: {
      type: String,
      default: "left",
    },
    closeNotif: Function,
  },
  data() {
    return {
      notif_style: [],
      text_align: [],
    };
  },
  created: function () {
    this.notif_style["success"] = "alert-success";
    this.notif_style["danger"] = "alert-danger";
    this.notif_style["warning"] = "alert-warning";
    this.notif_style["info"] = "alert-info";

    this.text_align["center"] = "text-center";
    this.text_align["right"] = "text-right";
    this.text_align["left"] = "text-left";
  },
};
</script>